import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useTheme } from "@mui/material/styles";

const CustomSearchBar = ({
  value,
  onChange,
  onClear,
  placeholder = "Search",
  minWidth = 220,
  height = 34,
  fontSize = "0.8rem",
  sx = {},
  ...props
}) => {
  const theme = useTheme();

  return (
    <TextField
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      size="small"
      sx={{
        flex: 1,
        minWidth,
        ...sx,

        "& .MuiOutlinedInput-root": {
          height,
          fontSize,
          borderRadius: 1,
          backgroundColor: theme.palette.background.paper,

          // default dashed border
          "& fieldset": {
            border: `1px dashed ${theme.palette.divider}`,
          },

          // hover
          "&:hover fieldset": {
            border: `1px solid ${theme.palette.text.primary}`,
          },

          // focus
          "&.Mui-focused fieldset": {
            border: `1px solid ${theme.palette.primary.main}`,
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon
              sx={{
                color: theme.palette.text.secondary,
                fontSize: 16,
              }}
            />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <ClearIcon
              sx={{
                color: theme.palette.text.secondary,
                fontSize: 16,
                cursor: "pointer",
                "&:hover": {
                  color: theme.palette.text.primary,
                },
              }}
              onClick={onClear}
            />
          </InputAdornment>
        ) : null,
      }}
      {...props}
    />
  );
};

export default CustomSearchBar;